import React, { useState, useEffect } from 'react';
import settingsIcon from '../images/settings01.png';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTenants, addTenant, changeTenant } from '../redux/actions';

const ManageTargets = () => {
    const logoURL = useSelector((state) => state.logoURL);
    const dispatch = useDispatch();
    const tenants = useSelector((state) => state.tenants);
    console.log('Current tenants:', tenants);
    
    // Default values
    const defaultValues = {
        name: '',
        tenantID: '',
        logo: '',
        orgID: '',
        clientAccountId: '',
        cash_url: 'https://paymentfunctions-uploadcampaigncauseprojecttransa-lsxnwb2pga-uc.a.run.app/',
        defaultTarget: 'lKWHLGcx1j4LoGVjqRJR',
        defaultTargetId: 'lKWHLGcx1j4LoGVjqRJR',
        fixedRate: 1.3,
        variablePercentage: 2.3,
        terminalId: '123',
        amt1: 10,
        amt2: 20,
        amt3: 50,
        amt4: 100
    };
    
    const [newTenant, setNewTenant] = useState(defaultValues);
    const [showForm, setShowForm] = useState(false);
    const userTenant = useSelector((state) => state.userTenant);

    useEffect(() => {
        dispatch(fetchTenants());
    }, [dispatch]);

    const handleAddTenant = () => {
        if (newTenant.name.trim() && newTenant.tenantID.trim()) {
            dispatch(addTenant(newTenant));
            setNewTenant(defaultValues);
            setShowForm(false);
        }
    };

    const handleShowForm = () => {
        setShowForm(true);
    };

    const handleSwitchTenant = (tenantId) => {
        console.log('Switching to tenant:', tenantId);
        dispatch(changeTenant(tenantId));
    };

    const handleInputChange = (field, value) => {
        setNewTenant(prev => ({
            ...prev,
            [field]: field === 'fixedRate' || field === 'variablePercentage' || 
                     field === 'amt1' || field === 'amt2' || field === 'amt3' || field === 'amt4'
                ? (value === '' ? '' : parseFloat(value) || 0)
                : value
        }));
    };

    return (
        <div className="min-h-screen flex justify-center">
            <div className="w-full max-w-screen-lg flex flex-col items-center space-y-3 px-4 md:px-16">
                <div className="w-full flex items-center justify-between p-2 bg-gray-100" style={{ height: '75px' }}>
                    <Link to="/">
                        <img src={logoURL} alt="Logo" className="h-15" style={{ width: "auto", height: '60px' }} />
                    </Link>

                    <div className="absolute left-1/2 transform -translate-x-1/2">

                    </div>
                    <Link to="/settings" className="h-6 w-6">
                        <img src={settingsIcon} alt="Settings" className="h-full w-full" />
                    </Link>
                </div>
                <h1>Manage Tenants & Targets</h1>

                <div className="w-full mt-8">
                    <h2 className="text-xl font-bold mb-4">Tenants:</h2>
                    <table className="min-w-full bg-white">
                        <thead>
                            <tr>
                                <th className="py-2">Name</th>
                                <th className="py-2">Tenant ID</th>
                                <th className="py-2">Logo</th>
                                <th className="py-2">Org ID</th>
                                <th className="py-2">Client Account ID</th>
                                <th className="py-2">Ready</th>
                                <th className="py-2">Switch Tenant</th>
                                <th className="py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tenants.map((tenant) => {
                                const isReady = tenant.locationsCreated === true;
                                return (
                                    <tr key={tenant.id} className={`text-center ${tenant.id === userTenant ? 'bg-blue-100' : ''}`}>
                                        <td className="py-2">{tenant.tenantName}</td>
                                        <td className="py-2">{tenant.id}</td>
                                        <td className="py-2"><img src={tenant.logo} alt="Logo" className="h-10 mx-auto" /></td>
                                        <td className="py-2">{tenant.org_id}</td>
                                        <td className="py-2">{tenant.clientAccountId}</td>
                                        <td className="py-2">
                                            {isReady ? (
                                                <span className="text-green-600 text-2xl">✓</span>
                                            ) : (
                                                <span className="text-red-600 text-2xl">✗</span>
                                            )}
                                        </td>
                                        <td className="py-2">
                                            {tenant.id !== userTenant && (
                                                <button
                                                    onClick={() => handleSwitchTenant(tenant.id)}
                                                    className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                                >
                                                    Switch
                                                </button>
                                            )}
                                        </td>
                                        <td className="py-2">
                                            <Link to={`/tenant/${tenant.id}`} className="px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600">
                                                Edit
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {tenants.some(tenant => tenant.locationsCreated !== true) && (
                        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                            <p className="text-red-800 font-medium">Please add stripe location to enable this tenant</p>
                        </div>
                    )}
                    <div className="mt-4">
                        <button onClick={handleShowForm} className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600">
                            + Add New Tenant
                        </button>
                        {showForm && (
                            <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <h3 className="text-lg font-semibold mb-4">Add New Tenant</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Tenant Name *</label>
                                        <input
                                            type="text"
                                            value={newTenant.name}
                                            onChange={(e) => handleInputChange('name', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder="Enter tenant name"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Tenant ID *</label>
                                        <input
                                            type="text"
                                            value={newTenant.tenantID}
                                            onChange={(e) => handleInputChange('tenantID', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder="Enter tenant ID"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
                                        <input
                                            type="text"
                                            value={newTenant.logo}
                                            onChange={(e) => handleInputChange('logo', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder="Enter logo URL"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Organization ID</label>
                                        <input
                                            type="text"
                                            value={newTenant.orgID}
                                            onChange={(e) => handleInputChange('orgID', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder="Enter org ID"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Client Account ID</label>
                                        <input
                                            type="text"
                                            value={newTenant.clientAccountId}
                                            onChange={(e) => handleInputChange('clientAccountId', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder="Enter client account ID"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Cash URL</label>
                                        <input
                                            type="text"
                                            value={newTenant.cash_url}
                                            onChange={(e) => handleInputChange('cash_url', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.cash_url}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Fixed Rate</label>
                                        <input
                                            type="number"
                                            step="0.1"
                                            value={newTenant.fixedRate}
                                            onChange={(e) => handleInputChange('fixedRate', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.fixedRate.toString()}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Variable Percentage</label>
                                        <input
                                            type="number"
                                            step="0.1"
                                            value={newTenant.variablePercentage}
                                            onChange={(e) => handleInputChange('variablePercentage', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.variablePercentage.toString()}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Terminal ID</label>
                                        <input
                                            type="text"
                                            value={newTenant.terminalId}
                                            onChange={(e) => handleInputChange('terminalId', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.terminalId}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount 1</label>
                                        <input
                                            type="number"
                                            value={newTenant.amt1}
                                            onChange={(e) => handleInputChange('amt1', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.amt1.toString()}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount 2</label>
                                        <input
                                            type="number"
                                            value={newTenant.amt2}
                                            onChange={(e) => handleInputChange('amt2', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.amt2.toString()}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount 3</label>
                                        <input
                                            type="number"
                                            value={newTenant.amt3}
                                            onChange={(e) => handleInputChange('amt3', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.amt3.toString()}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount 4</label>
                                        <input
                                            type="number"
                                            value={newTenant.amt4}
                                            onChange={(e) => handleInputChange('amt4', e.target.value)}
                                            className="px-3 py-2 border rounded w-full"
                                            placeholder={defaultValues.amt4.toString()}
                                        />
                                    </div>
                                </div>
                                <div className="mt-4 flex gap-2">
                                    <button onClick={handleAddTenant} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                                        Add Tenant
                                    </button>
                                    <button onClick={() => { setShowForm(false); setNewTenant(defaultValues); }} className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageTargets;
